import React, { useEffect, useRef } from "react";
import HeatmapLegend from "./HeatmapLegend";
import { TacticScale, Tactics, TacticsData } from "../types/data";
import Popover from "./Popover";
import { useState } from "react";
import TeamTable from "./TeamTable";
import CardWrapper from "./CardWrapper";
import PopoverCard from "./PopoverCard";
import PieChart from "./PieChart";
import Dropdown from "./Dropdown";
import {
  gamePrediction,
  tactical_analysis,
  team_configs,
} from "../router/resources/data";
import { PopupData } from "../types/data";

interface Props {
  tacticsData: TacticsData;
  defaultData: TacticsData;
  homeTeam: number;
  awayTeam: number;
  homeWin:number;
  awayWin: number;
  handleTacticsData: React.Dispatch<React.SetStateAction<TacticsData>>;
  scales: TacticScale;
  changeHomeTeam: (val: number) => void;
  changeAwayTeam: (val: number) => void;
  changeGamePrediction: () => void;
}

const TacticalDashboard: React.FC<Props> = ({tacticsData, handleTacticsData, defaultData, homeTeam, awayTeam, changeHomeTeam, changeAwayTeam, homeWin, awayWin, scales, changeGamePrediction}) => {
  const [open, setOpen] = useState(false);
  const [metric, setMetric] = useState<Tactics>();
  const [value, setValue] = useState<number>(0);
  const [isHome, setIsHome] = useState<boolean|undefined>();
  const [isEfficiency, setIsEfficiency] = useState<boolean>(false);

  const [popupData, setPopUpData] = useState<PopupData>();
  return  (
    <div>
      {open && (
        <PopoverCard closeModal={() => setOpen(false)}>
          <Popover
            metric={metric!}
            value={value}
            isEfficiency={isEfficiency}
            isHome={isHome!}
            handleValue={setValue}
            handleData={handleTacticsData}
            data={tacticsData}
            defaultData={defaultData}
            popupData={popupData!}
            setOpen={setOpen}
          />
        </PopoverCard>
      )}
      <div className="w-full flex flex-col items-center my-2">
      {/*
      
        <h1 className="text-4xl font-bold text-center my-5">
          Welcome to B11 Basketball Analysis
        </h1>
    */}
        <div className="w-full flex flex-row items-center mx-20 justify-center">
          <Dropdown
            homeTeam={homeTeam}
            awayTeam={awayTeam}
            setHomeTeam={changeHomeTeam}
            setAwayTeam={changeAwayTeam}
            disabled={false}
          ></Dropdown>
        </div>
        <div className="w-full flex flex-row items-center my-2 justify-center text-sm">
          <CardWrapper>
            <div className="text-center">High</div>
            <HeatmapLegend upperBound={100}></HeatmapLegend>
            <div className="text-center">Low</div>
          </CardWrapper>
          <CardWrapper>
            <TeamTable
              changeSetOpen={setOpen}
              tableData={tacticsData}
              defaultData={defaultData}
              handleMetric={setMetric}
              handleValue={setValue}
              handleIsHome={setIsHome}
              handlePopupData={setPopUpData}
              handleIsEfficiency={setIsEfficiency}
              scales={scales}
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              mode={0}
            />
          </CardWrapper>
          <div className="flex flex-col items-center my-10">
            <CardWrapper>
              <button
                className="bg-neutral-400 hover:bg-neutral-300 text-black font-bold py-2 px-4 rounded w-80"
                onClick={changeGamePrediction}
              >
                Make Predictions
              </button>
            </CardWrapper>
            <CardWrapper>
              <div className="text-center mx-2 my-5">Winning Probabilities</div>
              <PieChart
                home={homeWin}
                away={awayWin}
                width={350}
                height={300}
              />
            </CardWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TacticalDashboard;
